import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.settings', {
        url: '/settings',
        views: {
            '@company': 'companySharingCenterSettings'
        },
        resolve: {
            settingsDetails
        },
    });
}


/** @ngInject */
function settingsDetails(companyId,SharingSettingsService) {
return SharingSettingsService.getSettings({companyId}).$promise;
}







// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/sharing-settings/sharing-settings.state.js